// extracted by mini-css-extract-plugin
export default {"Modal":"modal_Modal__pBrHk","ModalContent":"modal_ModalContent__fkZ4l"};